import { Link } from 'react-router-dom';

export default function ServiceAreaSection() {
  const counties = [
    { name: 'Cuyahoga County', link: '/service-areas#cuyahoga' },
    { name: 'Summit County', link: '/service-areas#summit' },
    { name: 'Portage County', link: '/service-areas#portage' },
    { name: 'Geauga County', link: '/service-areas#geauga' },
    { name: 'Lake County', link: '/service-areas#lake' },
    { name: 'Lorain County', link: '/service-areas#lorain' },
    { name: 'Medina County', link: '/service-areas#medina' },
    { name: 'Stark County', link: '/service-areas#stark' },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Serving Injured Workers Throughout Northeast Ohio
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We represent workers' compensation clients across multiple counties in Northeast Ohio
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/0f108d9bde8311388ea71c3e4e023e12.jpg"
              alt="Northeast Ohio Service Area Map"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Counties We Serve</h3>
            <div className="space-y-3">
              {counties.map((county, index) => (
                <Link
                  key={index}
                  to={county.link}
                  className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:shadow-md hover:bg-teal-50 transition-all group"
                >
                  <span className="text-base font-medium text-gray-900 group-hover:text-teal-600">
                    {county.name}
                  </span>
                  <i className="ri-arrow-right-line text-gray-400 group-hover:text-teal-600 group-hover:translate-x-1 transition-all"></i>
                </Link>
              ))}
            </div>
            <div className="mt-8 p-6 bg-teal-50 rounded-xl">
              <p className="text-sm text-gray-700 leading-relaxed">
                <strong className="text-gray-900">Local Expertise:</strong> Our deep knowledge of Northeast Ohio's workers' compensation system, local courts, and regional employers gives our clients a significant advantage in their cases.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}